import React from "react";

import Notes from "../contexts/notes";
import NoteDisplay from "./notes-display";

const NoteLoader = ({ settings }) => {
    return (
        <Notes
            settings={{
                shipmentKey: settings.shipmentKey,
                shipmentProductKey: settings.shipmentProductKey,
            }}
            clientCode={settings.clientCode}
            binTrackingNumber={settings.binTrackingNumber}
            noteType={settings.noteType}
            sourcePage={settings.sourcePage}
        >
            {settings.upc && <h2>{settings.upc}</h2>}
            <NoteDisplay showAll={settings.showAll} taskType={settings.taskType} isReadOnly={settings.isReadOnly} />
        </Notes>
    );
};

export default NoteLoader;
